import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { SsrModule } from 'app/constants/ssrModules';
import { Spinner } from 'app/design-system/components/Spinner';

import { RootMenu } from '../../components/RootMenu';
import {
  entityLoading,
  matchIds,
  rootMenuItemsWithPathname,
} from '../../selectors/live';

export const LiveMenu: React.FC = () => {
  const { pathname } = useLocation();
  const hasMatchIds = useSelector(matchIds).size > 0;
  const loading = useSelector(entityLoading);
  const realLoading = !hasMatchIds && loading;
  const items = useSelector(rootMenuItemsWithPathname(pathname));

  return (
    <>
      {realLoading
        ? <Spinner size={40} />
        : (
          <RootMenu ssrDataId={SsrModule.LEFT_MENU_LIVE}
                    list={items} />
        )
      }
    </>
  );
};
